import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import XLSX from "xlsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MDBDataTable } from "mdbreact";
import _ from "lodash";
import "./styles.css";
import * as FileSaver from 'file-saver';
import LoadingOverlay from "react-loading-overlay";

import Util from '../../../Common/util';
import API from '../../../Common/api';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';

var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;
var Dispatch_From_Date_val;
var dispatch_to_Date_val;
const Heading = [['Bill Date','Dispatch Date','Warehouse Code','Brand','Bill ID','No. of unique SKUs','Total Bill Value','Subgroup ID','Packing Method','Crate ID']];

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.getCookie = this.getCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);

    this.state = {

      filtered_orderData: "",
      loader1: false,
      isDisabledApply: false,
      fromdate: "",
      todate: "",
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      bill_no: "",
      group_id: "",
      dispatchtodate : "",
      dispatchfromdate : "",
      cityData : [],
      warehouseData : [],
      clientData : [],
      brand_code:'',
      warehouse_code :'',
      city : ''

    };
  }

  onBillChange = (evt) => {
    this.setState({
      bill_no: evt.target.value.trim(),
    });
  };

  onGroupChange = (evt) => {
    this.setState({
      group_id: evt.target.value.trim(),
    });
  };

  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {
    this.setState({
      fromdate: date,
      showFromErr: false

    })
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({
        fromdate: ""
      })
      From_Date_val = ""
    }

  }

  ToDateChange = date => {

    this.setState({
      todate: date,
      showToErr: false
    })
    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({
        todate: "",

      })
      to_Date_val = ""
    }

  }
  DispatchFromDateChange = date  => {
    this.setState({
      dispatchfromdate :  date,
      showFromErr: false

    })  
    if(date){
      Dispatch_From_Date_val = this.convertDate(date);
    }else{
      this.setState({
        dispatchfromdate: ""
      })
      Dispatch_From_Date_val = ""
    }
    
}

  DispatchToDateChange = date => {
      
      this.setState({
        dispatchtodate :  date,
        showToErr: false
      }) 
      if(date){
        dispatch_to_Date_val = this.convertDate(date);
      }else{
        this.setState({
          dispatchtodate: "",
        
        })
        dispatch_to_Date_val= ""
      }
      
  }
  componentDidMount() {
    // this.fetchInventoryData();
    this.fetchWarehouseData();
    this.fetchBrandData();
    this.fetchCityData();
  }
  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var today = new Date();
    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
      },
      () => {
      }
    );
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  oncityChange = (evt) =>{
    this.setState({
      city : evt.target.value
    })
  }
  onwarehouseChange = (evt) => {
    this.setState({
      warehouse_code: evt.target.value
    })
  }
  onBrandChange = (evt) => {
    this.setState({
      brand_code: evt.target.value
    })
  }

  fetchCityData = () =>{
    const payload = {
    };
    API.post('/product/product_master/v1/city/dropdown/', { param: payload })
      .then((response) => response.data)
      .then((data) => {

        this.setState({
          //showFetchDispatchData: true,
          cityData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }
  fetchWarehouseData = () => {

    const payload = {


    };

    API.post('/product/product_master/v1/warehouse/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          //showFetchDispatchData: true,
          warehouseData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }

  fetchBrandData = () => {

    const payload = {

    };

    API.post('/product/product_master/v1/client/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          //showFetchDispatchData: true,
          clientData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }
  assembleDispatchData = (dispatchData) => {

    let DispatchData = dispatchData.map((post, index) => {

      return {
        bill_date: post.bill_date,
        dispatch_date: post.dispatch_date,
        warehouse_code: post.warehouse_code,
        brand: post.client_code,
        bill_id: post.outlet_order_no,
        unique_sku :post.skus_count,
        total_bill_value : post.total_bill_value,
        subgroup_id: post.ptl_id,
        packing_method : post.packing_station,
        crate_id: post.crate,
      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
      orderData: DispatchData,
      filtered_orderData: DispatchData,
    });

    return DispatchData;
  };

  fetchDispatch = (order_no) => {

    this.setState({
      //loading_overlay: true,
      loading: true,
    });
    if (!(this.state.brand_code) && !(this.state.warehouse_code) && !(this.state.city) && !(From_Date_val) && !(to_Date_val) && !(Dispatch_From_Date_val) && !(dispatch_to_Date_val)) {
      this.setState({
        filter_model :true,
        loading: false,
        loading_overlay: false
      })
    }
    else{
    // var batch = localStorage.getItem('batch_id');
    const payload = {
      "order_to_date": to_Date_val,
      "order_from_date": From_Date_val,
      "dispatch_from_date":Dispatch_From_Date_val,
      "dispatch_to_date" : dispatch_to_Date_val,
      "brand_code" : this.state.brand_code,
      "warehouse_code" : this.state.warehouse_code,
      "city_code" : this.state.city,
      

    };
    addAnalytics('Report', 'View Packed Crate', payload);

    API.post('/product/mis-packed-crates-report/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          showFetchDispatchData: true,
          loading: false
        });

        if (data.success == false) {
          this.setState({
            failed_message: data.message
          })
          this.toggle();
        }


        if (data.length == 0) {

          this.setState({
            dispatch_status: true,
            showFetchDispatchData: true,
            loading_overlay: false,
            loading: false,

          });
          return false;
        }

        this.setState({
          tableRowsMap: this.assembleDispatchData(data.data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function (error) { });
    }
  };
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData });
    } else {

      var value = this.state.orderData.filter(
        (val) => {
          return Object.keys(val).some(key => {
            var data = ""
            if (val[key] == null) {
              data = ""
            }
            else {
              data = val[key]
            }

            return data.toString().toLowerCase().includes(evt.toLowerCase())
          })
        }
      );

      this.setState({
        filtered_orderData: value,
      });
    }
  };

  render() {
    const { handleSubmit, reset, t } = this.props;

    const dispatchData = {
      columns: [
        {
          label: "Bill Date",

          field: "bill_date",
          width: 120,
        },
        {
          label: "Dispatch Date",

          field: "dispatch_date",
          width: 130,
        },

        {
          label: "Warehouse",

          field: "warehouse_code",
          width: 130,
        },
        {
          label: "Brand",

          field: "brand",
          width: 120,
        },
        {
          label: "Bill ID",

          field: "bill_id",
          width: 180,
        },
        {
          label: "No. of Unique SKUs",

          field: "unique_sku",
          width: 160,
        },
        {
          label: "Total Bill Value",

          field: "total_bill_value",
          width: 140,
        },
        {
          label: "Subgroup ID",

          field: "subgroup_id",
          width: 120,
        },
        {
          label: "Packing Method",

          field: "packing_method",
          width: 120,
        },
        {
          label: "Crate ID",

          field: "crate_id",
          width: 120,
        },
    
      ],

      rows: this.state.tableRowsMap,
    };

    return (
      <Col xl={12}>

        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
          <CardBody style={{ paddingTop: 10, height: 68, paddingBottom: 0 }}>
            <form className="form" onSubmit={handleSubmit}>


              <div  style={{width:'11%',marginBottom:'0px', float:'left', marginRight: 5}}>
                
          <DatePicker
                    selected={this.state.dispatchfromdate}
                    onChange={this.DispatchFromDateChange}
                    className="ledger_fromdate"
          placeholderText="Dispatch From Date"
                    format='yyyy-MM-dd'
                  />
                  {this.state.showFromErr &&
                  <span style={{color: 'red', fontSize: 11}}>Please Select Dispatch From Date</span>
                  }
              </div>
        <div  style={{width:'11%',marginBottom:'0px', float: 'left', marginRight: 5}}>
        <DatePicker 
                    selected={this.state.dispatchtodate}
                    onChange={this.DispatchToDateChange}
                    className="ledger_todate"
          placeholderText="Dispatch To Date"
                />
                {this.state.showToErr &&
                  <span style={{color: 'red', fontSize: 11}}>Please Select Dispatch To Date</span>
                  }
              </div>


              <div style={{ width: '11%', marginBottom: '0px', float: 'left', marginRight: 5, }}>

                <DatePicker
                  selected={this.state.fromdate}
                  onChange={this.FromDateChange}
                  className="ledger_fromdate"
                  placeholderText="Order From Date"
                  format='yyyy-MM-dd'
                />
                {this.state.showFromErr &&
                  <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                }
              </div>
              <div style={{ width: '11%', marginBottom: '0px', float: 'left', marginRight: 5, }}>
                <DatePicker
                  selected={this.state.todate}
                  onChange={this.ToDateChange}
                  className="ledger_todate"
                  placeholderText="Order To Date"
                />
                {this.state.showToErr &&
                  <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
                }
              </div>
              <div
                style={{ width: '12%', marginBottom: '0px', float: 'left', marginRight: 5, }}
              >
                <div
                  className="form__form-group-field"

                >
              <select
                    className="form-control"
                    style={{ fontSize: 13 }}
                    onChange={this.oncityChange}
                  >
                    <option value="">Select City</option>
                    {
                      this.state.cityData.length > 0 &&
                      this.state.cityData.map((cityData) => {
                        return (
                          <option value={cityData.name}>{cityData.name} </option>
                        );
                      })}
                  </select>
                  </div>
                  </div>
              <div style={{ width: '12%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                  <select
                    className="form-control"
                    style={{ fontSize: 13}}
                    onChange={this.onwarehouseChange}
                  >
                    <option value="">Select warehouse</option>
                    {
                      this.state.warehouseData.length > 0 &&
                      this.state.warehouseData.map((warehouseData) => {
                        return (
                          <option value={warehouseData.name}>{warehouseData.name} </option>
                        );
                      })}
                  </select>
              </div>
              <div style={{ width: '12%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                  <select
                    className="form-control"
                    style={{ fontSize: 13 }}
                    onChange={this.onBrandChange}
                  >
                    <option value="">Select Brand</option>
                    {
                      this.state.clientData.length > 0 &&
                      this.state.clientData.map((clientData) => {
                        return (
                          <option value={clientData.name}>{clientData.name} </option>
                        );
                      })}
                  </select>
                </div>

              <div style={{ width: '10%', marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchDispatch(this.state.order_no)}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>
                </ButtonToolbar>
              </div>

              <div style={{ width: '3%', marginBottom: '0px', float: 'left' }}>
                <Button type="button" className="btn btn-primary-outline"
                  style={{
                    cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                    backgroundColor: this.state.btnDisabled ? '#FFFFFF' : '#FFFFFF',
                  }}
                  id="button_enable"
                // onClick={this.downloadError}
                >

                  {/* <img src={require('../../../../images/download.png')} onClick={this.state.downloadError} /> */}
                  <img src={require('../../../../images/download.png')} onClick={(e) => exportToCSV(this.state.filtered_orderData, "Packing Report", Heading)} />
                </Button>
              </div>
            </form>
          </CardBody>
          {this.state.showFetchDispatchData && (
            <CardBody style={{ marginTop: 2, paddingTop: 0, paddingBottom: 0 }}>
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: -27 }}
              >
                <MDBDataTable
                  scrollX
                  scrollY
                  sortable={false}
                  maxHeight="390px"
                  displayEntries={false}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'Packed Crate Report', 'datatable_pagination_change' )}
                  striped
                  onSearch={this.filterData}
                  bordered
                  data={dispatchData}
                />
              </div>
            </CardBody>
          )}
        </Card>


      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
